export default "__VITE_ASSET__BIfjjBjI__"